var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ReportNav", [
    _c(
      "div",
      { staticClass: "compare-container" },
      [
        _c("div", { staticClass: "filter-box" }, [
          _c("div", { staticClass: "filter-head" }, [
            _c("div", { staticClass: "filter-head-text" }, [
              _c("span", [_vm._v("对比报告")]),
              _c("em", [_vm._v("请选择两份及以上的报告")]),
            ]),
          ]),
          _c("div", { staticClass: "filter-content" }, [
            _c(
              "div",
              {
                staticClass: "scroll-container",
                style: "width: " + _vm.scrollWidth,
              },
              [
                _vm._l(_vm.cardArr, function (item, index) {
                  return _c("div", { key: index, staticClass: "report-card" }, [
                    _c("div", { staticClass: "report-card-top" }, [
                      _c(
                        "div",
                        { staticClass: "flag", class: "flag-" + index },
                        [_vm._v(_vm._s(_vm.letterArr[index]))]
                      ),
                      _vm.cardArr.length > 2
                        ? _c("i", {
                            staticClass: "del-btn el-icon-delete",
                            on: {
                              click: function ($event) {
                                return _vm.delReport(index)
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("div", { staticClass: "row-title" }, [
                          _vm._v("报告" + _vm._s(_vm.letterArr[index])),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "row-select",
                            attrs: { placeholder: "请选择" },
                            on: {
                              change: function ($event) {
                                return _vm.changeReport(index)
                              },
                            },
                            model: {
                              value: item.reportId,
                              callback: function ($$v) {
                                _vm.$set(item, "reportId", $$v)
                              },
                              expression: "item.reportId",
                            },
                          },
                          _vm._l(_vm.reportList, function (reportOne) {
                            return _c("el-option", {
                              key: reportOne.inform_id + "",
                              attrs: {
                                label: reportOne.inform_name,
                                value: reportOne.inform_id + "",
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("div", { staticClass: "row-title" }, [
                          _vm._v("场景" + _vm._s(_vm.letterArr[index])),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "row-select",
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: item.section,
                              callback: function ($$v) {
                                _vm.$set(item, "section", $$v)
                              },
                              expression: "item.section",
                            },
                          },
                          _vm._l(
                            (_vm.reportInfoJson[item.reportId] &&
                              _vm.reportInfoJson[item.reportId].s_list) ||
                              [],
                            function (scenes, scenesIndex) {
                              return _c("el-option", {
                                key: scenesIndex,
                                attrs: {
                                  label:
                                    scenes.name +
                                    "(" +
                                    scenes.startFrame +
                                    "-" +
                                    scenes.endFrame +
                                    ")",
                                  value: scenesIndex,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                _vm.cardArr.length < _vm.letterArr.length
                  ? _c("div", { staticClass: "add-report report-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "add-report-btn",
                          on: { click: _vm.addReport },
                        },
                        [_vm._v("添加新报告")]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c(
            "div",
            { staticClass: "filter-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.compareHandle },
                },
                [_vm._v("查看对比数据")]
              ),
            ],
            1
          ),
        ]),
        _vm.compareData
          ? _c(
              "el-tabs",
              {
                attrs: { type: "border-card" },
                on: { "tab-click": _vm.tabClickHandle },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "性能对比概览" } },
                  [
                    _c(
                      "el-tabs",
                      { on: { "tab-click": _vm.tabClickHandle } },
                      _vm._l(_vm.compareData.chart, function (item, index) {
                        return _c(
                          "el-tab-pane",
                          { key: index, attrs: { label: item.title } },
                          [
                            _vm._l(item.line, function (one) {
                              return _c(
                                "div",
                                { key: one.id, staticClass: "line-item" },
                                [
                                  _c("line-chart", {
                                    ref: "chart",
                                    refInFor: true,
                                    staticClass: "line-chart",
                                    attrs: {
                                      id: one.id,
                                      "chart-data": one.data,
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            _c(
                              "div",
                              { staticClass: "bar-main" },
                              _vm._l(item.bar, function (one) {
                                return _c(
                                  "div",
                                  { key: one.id, staticClass: "bar-item" },
                                  [
                                    _c("line-chart", {
                                      ref: "chart",
                                      refInFor: true,
                                      staticClass: "bar-chart",
                                      attrs: {
                                        id: one.id,
                                        "chart-data": one.data,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ],
                          2
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "对比数据表" } },
                  _vm._l(_vm.compareData.table, function (tableData, index) {
                    return _c(
                      "el-table",
                      { key: index, attrs: { data: tableData, border: "" } },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "测试项" },
                        }),
                        _vm._l(_vm.tableCardArr, function (item, cardIndex) {
                          return _c("el-table-column", {
                            key: cardIndex,
                            attrs: {
                              prop: _vm.letterArr[cardIndex],
                              label:
                                _vm.reportMap[item.reportId].inform_name +
                                "【" +
                                _vm.reportInfoJson[item.reportId].s_list[
                                  item.section
                                ].startFrame +
                                "-" +
                                _vm.reportInfoJson[item.reportId].s_list[
                                  item.section
                                ].endFrame +
                                "帧】",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "table-cell-data",
                                          class: {
                                            danger:
                                              Boolean(
                                                row[_vm.letterArr[cardIndex]] &&
                                                  row[_vm.letterArr[cardIndex]]
                                                    .advice
                                              ) &&
                                              (row[_vm.letterArr[cardIndex]]
                                                .advice.symbol == "lt"
                                                ? row[_vm.letterArr[cardIndex]]
                                                    .advice.data[
                                                    _vm.reportDevice
                                                  ][
                                                    row[
                                                      _vm.letterArr[cardIndex]
                                                    ].advice.data.length - 1
                                                  ] >
                                                  row[_vm.letterArr[cardIndex]]
                                                    .value
                                                : row[_vm.letterArr[cardIndex]]
                                                    .advice.data[
                                                    _vm.reportDevice
                                                  ][
                                                    row[
                                                      _vm.letterArr[cardIndex]
                                                    ].advice.data.length - 1
                                                  ] <
                                                  row[_vm.letterArr[cardIndex]]
                                                    .value),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "table-cell-data-value",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    row[
                                                      _vm.letterArr[cardIndex]
                                                    ] &&
                                                      row[
                                                        _vm.letterArr[cardIndex]
                                                      ].value
                                                  )
                                                ),
                                              ]),
                                              _c("em", [
                                                row[_vm.letterArr[cardIndex]] &&
                                                row[_vm.letterArr[cardIndex]]
                                                  .value <
                                                  row[_vm.letterArr[0]].value
                                                  ? _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/xiajiang.svg"),
                                                        alt: "",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                row[_vm.letterArr[cardIndex]] &&
                                                row[_vm.letterArr[cardIndex]]
                                                  .value >
                                                  row[_vm.letterArr[0]].value
                                                  ? _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/shangsheng.svg"),
                                                        alt: "",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          ),
                                          row[_vm.letterArr[cardIndex]] &&
                                          row[_vm.letterArr[cardIndex]].advice
                                            ? _c(
                                                "span",
                                                { staticClass: "advice-value" },
                                                [
                                                  _vm._v(
                                                    "推荐：" +
                                                      _vm._s(
                                                        row[
                                                          _vm.letterArr[
                                                            cardIndex
                                                          ]
                                                        ].advice.data[
                                                          _vm.reportDevice
                                                        ][
                                                          row[
                                                            _vm.letterArr[
                                                              cardIndex
                                                            ]
                                                          ].advice.data.length -
                                                            1
                                                        ]
                                                      )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }),
                      ],
                      2
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _c("el-empty", { attrs: { description: "暂未获取到数据" } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }